
function navigatorTest() {
  let unknown      = '-';
  let nVer         = navigator.appVersion;
  let nAgt         = navigator.userAgent;
  let browser      = navigator.appName;
  let version      = '' + parseFloat(navigator.appVersion);
  let majorVersion = parseInt(navigator.appVersion, 10);
  let nameOffset, verOffset, ix;

  if ((verOffset = nAgt.indexOf('Opera')) !== -1) {
    browser = 'Opera';
    version = nAgt.substring(verOffset + 6);
    if ((verOffset = nAgt.indexOf('Version')) !== -1) {
      version = nAgt.substring(verOffset + 8);
    }
  }
  // Opera Next
  if ((verOffset = nAgt.indexOf('OPR')) !== -1) {
    browser = 'Opera';
    version = nAgt.substring(verOffset + 4);
  }
  // Edge
  else if ((verOffset = nAgt.indexOf('Edge')) !== -1) {
    browser = 'Microsoft Edge';
    version = nAgt.substring(verOffset + 5);
  }
  // MSIE
  else if ((verOffset = nAgt.indexOf('MSIE')) !== -1) {
    browser = 'Microsoft Internet Explorer';
    version = nAgt.substring(verOffset + 5);
  }
  // Chrome
  else if ((verOffset = nAgt.indexOf('Chrome')) !== -1) {
    browser = 'Chrome';
    version = nAgt.substring(verOffset + 7);
  }
  // Safari
  else if ((verOffset = nAgt.indexOf('Safari')) !== -1) {
    browser = 'Safari';
    version = nAgt.substring(verOffset + 7);
    if ((verOffset = nAgt.indexOf('Version')) !== -1) {
      version = nAgt.substring(verOffset + 8);
    }
  }
  // Firefox
  else if ((verOffset = nAgt.indexOf('Firefox')) !== -1) {
    browser = 'Firefox';
    version = nAgt.substring(verOffset + 8);
  }
  // MSIE 11+
  else if (nAgt.indexOf('Trident/') !== -1) {
    browser = 'Microsoft Internet Explorer';
    version = nAgt.substring(nAgt.indexOf('rv:') + 3);
  }
  // Other browsers
  else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
    browser = nAgt.substring(nameOffset, verOffset);
    version = nAgt.substring(verOffset + 1);
    if (browser.toLowerCase() === browser.toUpperCase()) {
      browser = navigator.appName;
    }
  }

  // trim the version string
  if ((ix = version.indexOf(';')) !== -1) version = version.substring(0, ix);
  if ((ix = version.indexOf(' ')) !== -1) version = version.substring(0, ix);
  if ((ix = version.indexOf(')')) !== -1) version = version.substring(0, ix);

  majorVersion = parseInt('' + version, 10);

  if (isNaN(majorVersion)) {
    version = '' + parseFloat(navigator.appVersion);
    majorVersion = parseInt(navigator.appVersion, 10);
  }

  // mobile version
  let mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(nVer);

  // cookie
  let cookieEnabled = (navigator.cookieEnabled) ? true : false;

  if (typeof navigator.cookieEnabled === 'undefined' && !cookieEnabled) {
    document.cookie = 'testcookie';
    cookieEnabled = (document.cookie.indexOf('testcookie') !== -1) ? true : false;
  }

  // system
  let os = unknown;
  let clientStrings = [
    { s: 'Windows 10', r: /(Windows 10.0|Windows NT 10.0)/ },
    { s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/ },
    { s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/ },
    { s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/ },
    { s: 'Windows Vista', r: /Windows NT 6.0/ },
    { s: 'Windows Server 2003', r: /Windows NT 5.2/ },
    { s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/ },
    { s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/ },
    { s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/ },
    { s: 'Windows 98', r: /(Windows 98|Win98)/ },
    { s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/ },
    { s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ },
    { s: 'Windows CE', r: /Windows CE/ },
    { s: 'Windows 3.11', r: /Win16/ },
    { s: 'Android', r: /Android/ },
    { s: 'Open BSD', r: /OpenBSD/ },
    { s: 'Sun OS', r: /SunOS/ },
    { s: 'Chrome OS', r: /CrOS/ },
    { s: 'Linux', r: /(Linux|X11(?!.*CrOS))/ },
    { s: 'iOS', r: /(iPhone|iPad|iPod)/ },
    { s: 'Mac OS X', r: /Mac OS X/ },
    { s: 'Mac OS', r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
    { s: 'QNX', r: /QNX/ },
    { s: 'UNIX', r: /UNIX/ },
    { s: 'BeOS', r: /BeOS/ },
    { s: 'OS/2', r: /OS\/2/ },
    { s: 'Search Bot', r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/ }
  ];

  for (let id in clientStrings) {
    let cs = clientStrings[id];
    if (cs.r.test(nAgt)) {
      os = cs.s;
      break;
    }
  }

  let osVersion = unknown;

  if (/Windows/.test(os)) {
    osVersion = /Windows (.*)/.exec(os)[1];
    os = 'Windows';
  }

  switch (os) {
    case 'Mac OS X':
      osVersion = /Mac OS X (10[\.\_\d]+)/.exec(nAgt)[1];
      break;

    case 'Android':
      osVersion = /Android ([\.\_\d]+)/.exec(nAgt)[1];
      break;

    case 'iOS':
      osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
      osVersion = osVersion[1] + '.' + osVersion[2] + '.' + (osVersion[3] | 0);
      break;
  }

  let browserAccess        = true;
  let browserVersionAccess = false;
  let javascriptAccess     = true;
  let html5Access          = true;
  let flashAccess          = false;

  if (browser === "Chrome") {
    if (majorVersion >= 46) { browserVersionAccess = true }
  } else if (browser === "Safari") {
    if (majorVersion >= 9) { browserVersionAccess = true }
  } else if (browser === "Microsoft Internet Explorer") {
    if (majorVersion >= 11) { browserVersionAccess = true }
  } else if (browser === "Firefox") {
    if (majorVersion >= 42) { browserVersionAccess = true }
  } else if (browser === "Opera") {
    if (majorVersion >= 48) { browserVersionAccess = true }
  }

  window.jscd = {
    browser: browser,
    browserAccess: browserAccess,
    browserMajorVersion: majorVersion,
    browserVersionAccess: browserVersionAccess,
    os: os,
    osVersion: osVersion,
    cookies: cookieEnabled,
    javascriptAccess: javascriptAccess,
    html5Access: html5Access,
    flashAccess: flashAccess,
  };
}

function measureBW(fn, time) {
  time = time || 1;
  let startTime, endTime, fileSize;
  let count = time;

  function measureBWSimple() {
    let xhr = new XMLHttpRequest();

    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4 && xhr.status === 200) {
        if (!fileSize) {
          fileSize = xhr.responseText.length;
        }

        count--;

        if (count <= 0) {
          endTime = Date.now();
          let speed = fileSize * time / ((endTime - startTime) / 1000) / 1024;
          fn && fn(Math.floor(speed));
        }
      }
    }

    xhr.open("GET", "https://upload.wikimedia.org/wikipedia/commons/5/51/Google.png", true);
    xhr.send();
  }

  startTime = Date.now();

  for (let x = time; x > 0; x--) {
    measureBWSimple()
  }
}

function formatFloat(num, pos) {
  let size = Math.pow(10, pos);
  return Math.round(num * size) / size;
}


navigatorTest();

measureBW((speed) => {
  speed = formatFloat(speed / 1024, 1);
  // console.log(speed + " Mbps");

  let bandwidthAccess = speed >= 2.5;

  let bandwidth = {
    speed: speed,
    access: bandwidthAccess
  }

  if (bandwidth.access === true) {
    document.getElementById("bandwidth").innerHTML = `<th scope="row">Determined bandwidth</th>
      <td>${bandwidth.speed} Mbps</td><td class="text-right"><i class="fa fa-check text-success"></i></td>`;
  } else {
    document.getElementById("bandwidth").innerHTML = `<th scope="row">Determined bandwidth</th>
      <td>${bandwidth.speed} Mbps</td><td class="text-right"><i class="fa fa-times text-danger"></i></td>`;
  }
}, 10);

document.getElementById("os").innerHTML = `<th scope="row">OS</th><td>${jscd.os} ${jscd.osVersion}
</td><td class="text-right"> <i class="fa fa-check text-success"></i></td>`;

document.getElementById("browser").innerHTML = `<th scope="row">Browser</th><td>${jscd.browser}</td>
<td class="text-right"><i class="fa fa-check text-success"></i></td>`;

if (jscd.browserVersionAccess === true) {

  document.getElementById("version").innerHTML = `<th scope="row">Version</th>
    <td>${jscd.browserMajorVersion}</td>
    <td class="text-right"><i class="fa fa-check text-success"></i></td>`;

} else {

  document.getElementById("version").innerHTML = `<th scope="row">Version</th><td>${jscd.browserMajorVersion}
    </td><td class="text-right"><i class="fa fa-times text-danger"></i></td>`;

}

document.getElementById("javascript").innerHTML = `<th scope="row">Javascript</th><td>Enabled</td>
    <td class="text-right"><i class="fa fa-check text-success"></i></td>`;

if (jscd.cookies === true) {
  document.getElementById("cookies").innerHTML = `<th scope="row">Cookies</th><td>Enabled</td>
    <td class="text-right"><i class="fa fa-check text-success"></i></td>`;
}
